<template>
  <div class="userInfo" v-loading="loading">
    <h2 class="fs30">个人资料</h2>
    <ul class="userInfoSearch">
      <li class="infoSearchType"
          v-for="(item, index) in searchList"
          :key="item.value"
          @click="searchType(item.value)">
        <div :class="{search_active: isActive === item.value}">{{ item.label }}</div>
        <div class="infoSearchTypeTool" v-if="index !== (searchList.length - 1)"/>
      </li>
    </ul>
    <!-- 基本信息 -->
    <div v-if="isActive === 0">
      <el-form ref="formData"
               :model="formData"
               :rules="rules"
               label-position="right"
               label-width="130px"
               class="generalInfo">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="formData.username" :disabled="true"/>
        </el-form-item>
        <el-form-item label="账号类型" prop="accountType">
          <el-input v-model="formData.accountType" :disabled="true"/>
        </el-form-item>
        <el-form-item :label="accountType ? '单位名称' : '个人名称'" prop="company">
          <el-input v-model="formData.company" :disabled="true"/>
        </el-form-item>
        <el-form-item label="联系人姓名" prop="nickname">
          <el-input v-model="formData.nickname" :disabled="true"/>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formData.phone"/>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="formData.email"/>
        </el-form-item>
        <template v-if="!accountType">
          <el-form-item label="开票类型" prop="invoiceType">
            <el-input v-model="formData.invoiceType" :disabled="true"/>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button class="submitBtn btn-shadow"
                     v-loading="btnLoading"
                     @click="onSubmit">保&emsp;存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 开票信息 -->
    <div v-if="isActive === 2">
      <el-form ref="formData"
               :model="formData"
               :rules="rules"
               label-position="right"
               label-width="130px"
               class="generalInfo">
        <el-form-item label="开票类型" prop="invoiceType">
          <el-input v-model="formData.invoiceType" :disabled="true"/>
        </el-form-item>
        <template v-if="accountType">
          <el-form-item label="纳税人识别号" prop="taxId">
            <el-input v-model="formData.taxId"/>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="formData.address"/>
          </el-form-item>
          <el-form-item label="开户行" prop="bank">
            <el-input v-model="formData.bank"/>
          </el-form-item>
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input v-model="formData.bankAccount"/>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button class="submitBtn btn-shadow"
                     v-loading="btnLoading"
                     @click="onSubmit">保&emsp;存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 修改密码 -->
    <div v-if="isActive === 1" class="resetPwd">
      <el-form ref="pwdFormData"
               :model="pwdFormData"
               :rules="pwdRules"
               label-position="right"
               label-width="150px"
               class="generalInfo">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="pwdFormData.username" :disabled="true"/>
        </el-form-item>
        <el-form-item label="原密码" prop="originPwd">
          <el-input type="password"
                    v-model="pwdFormData.originPwd"
                    auto-complete="new-password"
                    show-password/>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input type="password"
                    v-model="pwdFormData.newPwd"
                    auto-complete="new-password"
                    :minlength="pwd_min"
                    :maxlength="pwd_max"
                    show-password/>
        </el-form-item>
        <el-form-item label="确认新密码" prop="newPwdAgain">
          <el-input type="password"
                    v-model="pwdFormData.newPwdAgain"
                    auto-complete="new-password"
                    :minlength="pwd_min"
                    :maxlength="pwd_max"
                    show-password/>
        </el-form-item>
        <el-form-item>
          <el-button class="submitBtn btn-shadow"
                     v-loading="pwdBtnLoading"
                     @click="confirm">确认修改</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
// api
import { getUserInfo, editUserInfo } from '@/api/login.js'
import { changePassword } from '@/api/user.js'
// config
import { PWD, billingTypeConfig, validateStrongPwd } from '@/config/bkjcStroeConfig.js'
export default {
  name: 'userInfo',
  data () {
    const validatePwdAgain = (rule, value, cb) => {
      if(value !== this.pwdFormData.newPwd) {
        cb(new Error('两次输入密码不一致'));
      } else {
        cb();
      }
    };
    return {
      // 顶部菜单栏
      // searchList: [
      //   { 'label': '基本信息', 'value': 0 },
      //   { 'label': '开票信息', 'value': 2 },
      //   { 'label': '修改密码', 'value': 1 }
      // ],
      isActive: 0,  // 选中的菜单index
      loading: false,  // 模块加载

      // 基本信息
      formData: {
        avatar: '',
        username: '',
        accountType: '',
        company: '',
        // 开票信息
        invoiceType: '',  // 0:普通发票(电子) 1:普通发票(纸票) 2:增值税专用发票
        taxId: '',
        address: '',
        bank: '',
        bankAccount: '',
        // 联系人信息
        nickname: '',
        phone: '',
        email: ''
      },
      accountType: '',  // 0: 个人账号->false 1: 单位账号->true
      btnLoading: false,  // 保存按钮加载

      // 修改密码
      pwdFormData: {
        username: '',  // 展示
        originPwd: '',
        newPwd: '',
        newPwdAgain: ''
      },
      // 密码长度
      pwd_min: PWD.min,
      pwd_max: PWD.max,
      pwdRules: {  // 修改密码校验规则
        originPwd: [
          { required: true, message: '原密码不能为空', trigger: 'blur' },
          // 为了兼容强/弱口令密码，暂不校验原密码的长度
          // { min: 4, max: 16, message: '长度在 4 到 16 个字符', trigger: 'blur' },
        ],
        newPwd: [
          { required: true, message: '新密码不能为空', trigger: 'blur' },
          { min: PWD.min, max: PWD.max, message: `长度在 ${PWD.min} 到 ${PWD.max} 个字符`, trigger: 'blur' },
          { validator: validateStrongPwd, trigger: 'blur' },
        ],
        newPwdAgain: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validatePwdAgain, trigger: 'blur' },
          { min: PWD.min, max: PWD.max, message: `长度在 ${PWD.min} 到 ${PWD.max} 个字符`, trigger: 'blur' },
          { validator: validateStrongPwd, trigger: 'blur' },
        ],
      },
      pwdBtnLoading: false,  // 确认修改按钮加载
    }
  },
  computed: {
    // 基本信息校验规则：根据accountType计算
    rules() {
      return {
        taxId: [{ required: this.accountType, message: '单位账号，纳税人识别号不能为空', trigger: 'blur' }],
        address: [{ required: this.accountType, message: '单位账号，地址不能为空', trigger: 'blur' }],
        bank: [{ required: this.accountType, message: '单位账号，开户行不能为空', trigger: 'blur' }],
        bankAccount: [{ required: this.accountType, message: '单位账号，银行账号不能为空', trigger: 'blur' }],
        phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' },
          { required: true, pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/, message: '请填写正确的手机号格式', trigger: 'blur' }],
        email: [{ type: 'email', message: '请填写正确的邮箱格式', trigger: ['blur']}],
      }
    },
    // 顶部菜单栏：根据accountType计算
    searchList() {
      if(this.accountType) {  // 单位账号
        return [
          { 'label': '基本信息', 'value': 0 },
          { 'label': '开票信息', 'value': 2 },
          { 'label': '修改密码', 'value': 1 }
        ];
      } else {  // 个人账号
        return [
          { 'label': '基本信息', 'value': 0 },
          { 'label': '修改密码', 'value': 1 }
        ];
      }
    }
  },
  watch: {
    formData: {
      deep: true,
      handler(nVal, oVal) { console.log(nVal);}
    }
  },
  mounted () {
    this.getUserInfo();
  },
  methods: {
    // 获取用户信息
    async getUserInfo () {
      this.loading = true;
      let res = await getUserInfo();
      if (res.status === 200) {
        // 基本信息
        this.formData.avatar = res.data.avatar;
        this.formData.username = res.data.username;
        this.formData.company = res.data.additional.company;
        // 开票信息
        // 0:普通发票(电子) 1:普通发票(纸票) 2:增值税专用发票
        this.formData.invoiceType = billingTypeConfig[res.data.additional.invoiceType];
        // 0: 个人账号->false 1: 单位账号->true
        this.accountType = !!Number(res.data.additional.accountType);
        this.formData.accountType = this.accountType ? '单位账号' : '个人账号';
        this.formData.taxId = res.data.additional.taxId;
        this.formData.address = res.data.additional.address;
        this.formData.bank = res.data.additional.bank;
        this.formData.bankAccount = res.data.additional.bankAccount;
        this.formData.nickname = res.data.nickname;
        this.formData.phone = res.data.phone;
        this.formData.email = res.data.additional.email;
        // 修改密码
        this.pwdFormData.nickname = res.data.nickname;
        this.pwdFormData.phone = res.data.phone;
        this.pwdFormData.username = res.data.username;
        this.pwdFormData.originPwd = '';
        this.pwdFormData.newPwd = '';
        this.pwdFormData.newPwdAgain = '';
        this.loading = false;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 切换顶部导航
    searchType(value) {
      this.isActive = value;
      this.getUserInfo();
    },
    // 修改基本信息
    onSubmit () {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          editUserInfo(this.formData).then(res => {
            if (res.status === 200) {
              this.$message.success('修改成功');
              this.getUserInfo();
            } else {
              this.$message.warning(res.msg);
            }
            this.btnLoading = false;
          });
        } else {
          return false;
        }
      });
    },
    // 修改密码
    confirm() {
      this.$refs['pwdFormData'].validate((valid) => {
        if (valid) {
          this.pwdBtnLoading = true;
          changePassword({
            username: this.pwdFormData.username,  // 用户名
            password: this.pwdFormData.originPwd,  // 原密码
            newPassword: this.pwdFormData.newPwd  // 新密码
          }).then(res => {
            if(res.status === 200) {
              this.$message.success('修改成功');
              this.getUserInfo();
            } else {
              this.$message.error(res.msg);
            }
            this.pwdBtnLoading = false;
          });
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.userInfo{
  padding: 30px;
  background-color: #fff;
  // 导航菜单
  .userInfoSearch{
    height: 55px;
    line-height: 54px;
    width: 100%;
    margin: 20px 0;
    display: flex;
    .infoSearchType{
      font-size: 18px;
      cursor: pointer;
      color: #666666;
      display: flex;
    }
    .infoSearchTypeTool{
      width: 1px;
      height: 18px;
      margin: 24px 10px 0 10px;
      background-color: #CDCDCD;
    }
    .search_active{
      font-weight: bold;
      color: #333333;
      border-bottom: 2px solid #F26E47;
    }
  }
  // 基本信息
  .generalInfo{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .submitBtn{
    background-color: $plainBtnColor;
    color: #fff;
    &:hover{
      background-color: $plainBtnSelectedColor;
    }
  }
  .pwdBtn{
    border: 1px solid #CCCCCC;
  }
  .pwdBtn:hover{
    border: 1px solid #c6e2ff;
  }
  >>>.el-form{
    .el-form-item{
      .el-input{
        width: 240px;
      }
    }
  }

  // 修改密码对话框
  >>>.el-dialog{
    .el-dialog__header{
      padding-top: 60px;
      .el-dialog__title{
        font-size: 26px;
      }
    }
    .el-dialog__body{
      padding: 25px 60px;
      box-sizing: border-box;
      p{
        font-size: 18px;
      }
      .default{
        img{
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
        span{
          font-size: 18px;
        }
      }
    }
    .el-dialog__footer{
      padding-bottom: 60px;
      .el-button{
        font-size: 18px;
        padding: 20px 75px;
        border-radius: 0;
        border: 1px solid #333333;
      }
      .close{
        color: #333333;
      }
      .submit{
        background-color: #333333;
        color: #FFFFFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/userInfo/index3.vue